import React, { useEffect, useState } from 'react';
import * as Sentry from '@sentry/react';
import api from '../../util/Api';
import { getAppVersion, getBuildTime } from '../../util';

// Module-level cache so the API version is fetched once per page load,
// not on every mount (login screen, sidebar, navigation).
let apiInfoCache = null;

const AppVersion = ({ className }) => {
  const uiVersion = getAppVersion();
  const uiBuildTime = getBuildTime();
  const [apiInfo, setApiInfo] = useState(apiInfoCache);

  useEffect(() => {
    Sentry.setTag('ui_version', uiVersion);
    Sentry.setTag('ui_build_time', uiBuildTime);
  }, [uiVersion, uiBuildTime]);

  useEffect(() => {
    if (apiInfoCache) {
      return undefined;
    }
    let active = true;
    api
      .get('/version')
      .then(({ data }) => {
        apiInfoCache = data || {};
        if (active) {
          setApiInfo(apiInfoCache);
        }
        Sentry.setTag('api_version', apiInfoCache.version || 'unknown');
        Sentry.setTag('api_build_time', apiInfoCache.buildTime || '');
      })
      .catch(() => {
        // API version is optional for the UI; ignore failures.
      });
    return () => {
      active = false;
    };
  }, []);

  const apiVersion = apiInfo && apiInfo.version ? apiInfo.version : '...';
  const apiBuildTime = apiInfo && apiInfo.buildTime ? apiInfo.buildTime : '';

  const uiPart = `UI: ${uiVersion}${uiBuildTime ? ` (${uiBuildTime})` : ''}`;
  const apiPart = `API: ${apiVersion}${apiBuildTime ? ` (${apiBuildTime})` : ''}`;
  const hint = `${uiPart}, ${apiPart}`;

  return (
    <div
      className={className || 'text-center text-muted small mt-2'}
      title={hint}
      style={{ cursor: 'default', userSelect: 'none' }}
    >
      {uiVersion}
    </div>
  );
};

export default AppVersion;
